// initial state
const state = {
  status: "",
  unreadNotification: 0
};

// getters
const getters = {
  getUnreadNotification: state => {
    return state.unreadNotification;
  }
};

// actions
const actions = {
  setUnreadNotification({ commit }, unreadNotification) {
    commit("success", {
      unreadNotification: unreadNotification
    });
  }
};

// mutations
const mutations = {
  success(state, payload) {
    state.status = "success";
    state.unreadNotification = payload.unreadNotification;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
